import React, { useEffect, useRef, useState } from "react";
import { Paper } from "@material-ui/core";
import { baseUrl } from "../../../../services/config";
import "../AccountLedger/AccountLedger.css";
import Select from "react-select";
import { useAlert } from "react-alert";
import { Table, Spinner } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import { DatePicker } from "antd";
import { upperCase } from "lodash";
import { DownloadTableExcel } from "react-export-table-to-excel";
const { RangePicker } = DatePicker;

const BankTransactionDateWise = () => {
  const [subAccount, setSubAccount] = useState({
    label: "Select Account",
    value: "",
  });
  const [sessionData, setSessionData] = useState([]);
  const [yearId, setYearId] = useState("");
  const [from, setFrom] = useState("00");
  const [toDate, setToDate] = useState("00");
  const [loading, setLoading] = useState(false);
  const [sub_AccountData, setSub_AccountData] = useState({
    label: "Select Account",
    value: "",
  });
  const [subtoatal, setSubTotal] = useState(false);
  // for response data//////////////
  const [balance, setBalance] = useState({});
  const [account, setAccount] = useState({});
  const [transactions, settransactions] = useState([]);
  const [select, setSelect] = useState([]);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const [newOpeningBln, setNewOpeningBln] = useState();
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const [customToRise, setCustomT0Rise] = useState();

  let authtoken = localStorage.getItem("userToken");

  const [directorSign, setDirectorSign] = useState(0);
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const alert = useAlert();
  const [isVisible, setIsVisible] = useState(false);
  const tableRef = useRef(null);

  useEffect(() => {
    sessions();
    accounts();
    getSettingData();
  }, []);
  ////getSessions//////////////////////////

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data.payload[0].director_sign);
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
        setDirectorSign(data.payload.settings.director_sign);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const accounts = () => {
    fetch(`${baseUrl}/subaccount`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];
        console.log(data);
        data.payload.forEach((element) => {
          arr.push({
            label: element.title + `(${element.acode})`,
            value: element.id,
            account_chart_id: element.account_chart_id,
          });
        });
        setSelect(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = () => {
    const data = {
      from: from,
      to: toDate,
      year_id: yearId,
    };

    setLoading(true);
    setIsVisible(false);

    fetch(`${baseUrl}/bank_transaction_date_wise_report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setIsVisible(true);

        if (data.metadata && data.metadata.success) {
          const allAccounts = data.payload; // now an array of subAccounts
          const processedAccounts = allAccounts.map((accountData) => {
            const openingBalance =
              accountData.openning_balance_credit !== 0
                ? accountData.openning_balance_credit
                : accountData.openning_balance_debit;
            const riseDebit = accountData.openning_balance_credit !== 0 ? 0 : 1;

            const transactionsWithBalance = balanceCalculator(
              accountData.transactions,
              openingBalance,
              riseDebit,
            );

            const totalDebit = transactionsWithBalance.reduce(
              (sum, t) => sum + parseFloat(t.debit),
              0,
            );
            const totalCredit = transactionsWithBalance.reduce(
              (sum, t) => sum + parseFloat(t.credit),
              0,
            );

            return {
              ...accountData,
              openingBalance,
              riseDebit,
              transactions: transactionsWithBalance,
              totalDebit,
              totalCredit,
            };
          });
          console.log("processedAccounts", processedAccounts);
          setNewOpeningBln(processedAccounts); // store all accounts in state
          setSubTotal(true);
        } else {
          console.log(data.metadata.message);
          if (typeof data.metadata.message === "object") {
            Object.values(data.metadata.message).forEach((msg) =>
              alert.error(msg),
            );
          } else {
            alert.error(data.metadata.message);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        alert.error("Error");
        setLoading(false);
        setSubTotal(false);
      });
  };

  const balanceCalculator = (dataList, openingBlnc, riseDebit) => {
    let array = [...dataList];
    let newArray = [];
    let blnc = openingBlnc;

    if (array.length > 0) {
      array.forEach((item) => {
        blnc = riseDebit === 0 ? blnc + item.credit : blnc + item.debit;
        blnc = riseDebit === 0 ? blnc - item.debit : blnc - item.credit;

        newArray.push({
          type:
            riseDebit === 1 ? (blnc < 0 ? "CR" : "DR") : blnc < 0 ? "DR" : "CR",
          blnc,
          ...item,
        });
      });
    }

    return newArray;
  };

  const accountFunc = (e) => {
    setSub_AccountData(e);
    console.log(e);
  };

  const gettotaldebit = () => {
    let sum = 0;
    transactions &&
      transactions.forEach((element) => {
        sum += parseInt(element.debit);
      });
    return sum;
  };

  const gettotalCredit = () => {
    let sum = 0;
    transactions &&
      transactions.forEach((element) => {
        sum += parseInt(element.credit);
      });
    return sum;
  };

  const getTotalDebit = (transactions) => {
    return transactions.reduce((sum, t) => sum + parseFloat(t.debit), 0);
  };

  const getTotalCredit = (transactions) => {
    return transactions.reduce((sum, t) => sum + parseFloat(t.credit), 0);
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const datePicker = (value, dateString) => {
    console.log("Formatted Selected Time: ", dateString);
    if (dateString[0] != "") setFrom(dateString[0]);
    else setFrom("00");

    if (dateString[1] != "") setToDate(dateString[1]);
    else setToDate("00");
  };
  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="d-flex mt-3 datepickerContaine">
          <div className="col-md-3">
            <label className="form-control-label">
              <b>
                Select Session
                <span style={{ color: "red", fontSize: 12 }}>*</span>
              </b>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="year_id"
              value={yearId}
              aria-label="Default select example"
              onChange={(e) => setYearId(e.target.value)}
            >
              <option value="">Select Session</option>
              {sessionData &&
                sessionData.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.year}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-4 d-flex flex-column">
            <label className="form-control-label">
              <b>Select Date</b>{" "}
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <RangePicker style={{ height: 40 }} onChange={datePicker} />
          </div>

          <div className="col-md-5 mt-7">
            <button className="btn btn-primary" onClick={handleSubmit}>
              Show
            </button>

            {newOpeningBln?.length > 0 ? (
              <>
                <ReactToPrint
                  documentTitle={`Account Ledger`}
                  pageStyle="auto"
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary w-105px mx-2"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                <DownloadTableExcel
                  filename="Bank Transaction - Date Wise Report"
                  sheet="Bank Transaction - Date Wise Report"
                  currentTableRef={tableRef.current}
                >
                  <button className="btn btn-primary mx-2"> Export </button>
                </DownloadTableExcel>
              </>
            ) : null}
          </div>
        </div>
        <br />
        <br />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : isVisible ? (
          <div id="tableboot">
            <div className="row">
              <div className="col-md-1">
                <img
                  style={{ height: 110, width: 100 }}
                  src={icon}
                  alt="logo"
                />
              </div>
              <div
                className="col-md-10"
                style={{ paddingTop: "10px", marginLeft: "25px" }}
              >
                <h1>{unitName}</h1>
                <h3>Bank Transaction - Date Wise Report</h3>
                <div className="d-flex justify-content-between">
                  <h4>
                    Transaction Dates :- {from} To {toDate}
                  </h4>
                </div>
              </div>
            </div>
            <Table responsive>
              <thead>
                <tr id="tbl" className="text-center">
                  <th className="w-120px">Date</th>
                  <th>VNoVType</th>
                  <th>Description</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th className="text-center">Balance</th>
                </tr>
              </thead>

              <tbody>
                {newOpeningBln?.map((account, idx) => (
                  <React.Fragment key={idx}>
                    {/* Account Title Row */}
                    <tr className="text-center text-color-primary">
                      <td
                        colSpan={6}
                        style={{
                          fontWeight: "bolder",
                          textAlign: "center",
                          fontSize: "14px",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                      >
                        {account.account_head?.title ||
                          account.account_head?.name}
                      </td>
                    </tr>

                    {/* Opening Balance Row */}
                    <tr id="tbl" className="text-center text-black">
                      <th></th>
                      <th></th>
                      <th>Opening Balance</th>
                      <th>
                        {Intl.NumberFormat("en-Us").format(
                          account.openning_balance_debit,
                        )}
                      </th>
                      <th>
                        {Intl.NumberFormat("en-Us").format(
                          account.openning_balance_credit,
                        )}
                      </th>
                      <th></th>
                    </tr>

                    {/* Transactions */}
                    {account.transactions?.map((item, i) => (
                      <tr id="tbl" className="text-center" key={i}>
                        <td style={{ color: "black" }}>
                          {item?.voucher?.date}
                        </td>
                        <td style={{ color: "black" }}>
                          {item.voucher?.voucher_no}
                        </td>
                        <td
                          style={{ color: "black" }}
                          className="text_align_start"
                        >
                          {item?.remarks &&
                          typeof item.remarks === "string" &&
                          !item.remarks.includes("Campus") &&
                          item?.campus
                            ? item?.remarks + " ( " + item?.campus?.name + " )"
                            : item?.remarks}
                        </td>
                        <td style={{ color: "black" }}>
                          {Intl.NumberFormat("en-Us").format(item.debit)}
                        </td>
                        <td style={{ color: "black" }}>
                          {Intl.NumberFormat("en-Us").format(item.credit)}
                        </td>
                        <td style={{ color: "black", width: "150px" }}>
                          {Intl.NumberFormat("en-Us").format(
                            Math.abs(item.blnc),
                          )}{" "}
                          {Math.abs(item.blnc) !== 0 ? item.type : ""}
                        </td>
                      </tr>
                    ))}

                    {/* Subtotal Row */}
                    {subtoatal && account.transactions?.length > 0 && (
                      <tr
                        id="tbl"
                        className="text-center"
                        style={{ borderTop: "1px solid black" }}
                      >
                        <td colSpan={2}></td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bolder",
                            textAlign: "end",
                            fontSize: "16px",
                            borderTop: "2px solid black",
                            borderBottom: "2px solid black",
                          }}
                        >
                          Grand Total :-{" "}
                        </td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bolder",
                            fontSize: "16px",
                            borderTop: "2px solid black",
                            borderBottom: "2px solid black",
                          }}
                        >
                          {Intl.NumberFormat("en-Us").format(
                            account.transactions.reduce(
                              (sum, t) => sum + parseFloat(t.debit),
                              0,
                            ),
                          )}
                        </td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bolder",
                            fontSize: "16px",
                            borderTop: "2px solid black",
                            borderBottom: "2px solid black",
                          }}
                        >
                          {Intl.NumberFormat("en-Us").format(
                            account.transactions.reduce(
                              (sum, t) => sum + parseFloat(t.credit),
                              0,
                            ),
                          )}
                        </td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bolder",
                            fontSize: "16px",
                            borderTop: "2px solid black",
                            borderBottom: "2px solid black",
                          }}
                        >
                          {Intl.NumberFormat("en-Us").format(
                            Math.abs(
                              account.transactions[
                                account.transactions.length - 1
                              ].blnc,
                            ),
                          )}{" "}
                          {Math.abs(
                            account.transactions[
                              account.transactions.length - 1
                            ].blnc,
                          ) !== 0
                            ? account.transactions[
                                account.transactions.length - 1
                              ].type
                            : ""}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </div>
        ) : null}
      </Paper>

      {/* for print/// */}

      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <div className="p-3" style={{ display: "flex" }}>
          <img
            // className='col-md-2'
            style={{ height: 110, width: 120 }}
            src={icon}
          />

          <div
            className="col-md-8"
            style={{ paddingTop: "10px", marginLeft: "25px" }}
          >
            <h1>{unitName}</h1>
            <h3>Bank Transaction - Date Wise Report</h3>
            <div className="d-flex justify-content-between">
              <h4>
                Transaction Dates :- {from} To {toDate}
              </h4>
            </div>
          </div>
        </div>

        <div id="tableboot">
          <Table>
            <thead>
              <tr id="tbl" className="text-center">
                <th style={{ fontSize: "16px" }} className="w-120px">
                  Date
                </th>
                <th style={{ fontSize: "16px" }}>VNoVType</th>
                <th style={{ fontSize: "16px" }}>Description</th>
                <th style={{ fontSize: "16px" }}>Debit</th>
                <th style={{ fontSize: "16px" }}>Credit</th>
                <th style={{ fontSize: "16px" }}>Balance</th>
              </tr>
            </thead>

            <tbody>
              {newOpeningBln?.map((account, idx) => (
                <React.Fragment key={idx}>
                  {/* Account Title Row */}
                  <tr className="text-center text-color-primary">
                    <td
                      colSpan={6}
                      style={{
                        fontWeight: "bolder",
                        textAlign: "center",
                        borderTop: "1px solid black",
                        borderBottom: "1px solid black",
                        whiteSpace: "normal",
                        padding: "1px",
                        fontSize: "16px",
                      }}
                    >
                      {account.account_head?.title ||
                        account.account_head?.name}
                    </td>
                  </tr>

                  {/* Opening Balance Row */}
                  <tr id="tbl" className="text-center text-black">
                    <th></th>
                    <th></th>
                    <th
                      style={{
                        color: "black",
                        whiteSpace: "normal",
                        padding: "1px",
                        fontSize: "14px",
                      }}
                    >
                      Opening Balance
                    </th>
                    <th
                      style={{
                        color: "black",
                        whiteSpace: "normal",
                        padding: "1px",
                        fontSize: "14px",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        account.openning_balance_debit,
                      )}
                    </th>
                    <th
                      style={{
                        color: "black",
                        whiteSpace: "normal",
                        padding: "1px",
                        fontSize: "14px",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        account.openning_balance_credit,
                      )}
                    </th>
                    <th></th>
                  </tr>

                  {/* Transactions */}
                  {account.transactions?.map((item, i) => (
                    <tr id="tbl" className="text-center" key={i}>
                      <td
                        style={{
                          color: "black",
                          whiteSpace: "normal",
                          padding: "1px",
                          fontSize: "14px",
                        }}
                      >
                        {item?.voucher?.date}
                      </td>
                      <td
                        style={{
                          color: "black",
                          whiteSpace: "normal",
                          padding: "1px",
                          fontSize: "14px",
                        }}
                      >
                        {item.voucher?.voucher_no}
                      </td>
                      <td
                        style={{
                          color: "black",
                          whiteSpace: "normal",
                          fontSize: "14px",
                          padding: "1px",
                          textAlign: "start",
                        }}
                      >
                        {item?.remarks &&
                        typeof item.remarks === "string" &&
                        !item.remarks.includes("Campus") &&
                        item?.campus
                          ? item?.remarks + " ( " + item?.campus?.name + " )"
                          : item?.remarks}
                      </td>
                      <td
                        style={{
                          color: "black",
                          whiteSpace: "normal",
                          fontSize: "14px",
                          padding: "1px",
                        }}
                      >
                        {Intl.NumberFormat("en-Us").format(item.debit)}
                      </td>
                      <td
                        style={{
                          color: "black",
                          whiteSpace: "normal",
                          fontSize: "14px",
                          padding: "1px",
                        }}
                      >
                        {Intl.NumberFormat("en-Us").format(item.credit)}
                      </td>
                      <td
                        style={{
                          color: "black",
                          whiteSpace: "normal",
                          padding: "1px",
                          fontSize: "14px",
                          width: "150px",
                        }}
                      >
                        {Intl.NumberFormat("en-Us").format(Math.abs(item.blnc))}{" "}
                        {Math.abs(item.blnc) !== 0 ? item.type : ""}
                      </td>
                    </tr>
                  ))}

                  {/* Subtotal Row */}
                  {subtoatal && account.transactions?.length > 0 && (
                    <tr id="tbl" className="text-center">
                      <td colSpan={2}></td>
                      <td
                        style={{
                          color: "black",
                          fontWeight: "bolder",
                          fontSize: "14px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        Grand Total :-{" "}
                      </td>
                      <td
                        style={{
                          color: "black",
                          fontWeight: "bolder",
                          fontSize: "14px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        {Intl.NumberFormat("en-Us").format(
                          account.transactions.reduce(
                            (sum, t) => sum + parseFloat(t.debit),
                            0,
                          ),
                        )}
                      </td>
                      <td
                        style={{
                          color: "black",
                          fontWeight: "bolder",
                          fontSize: "14px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        {Intl.NumberFormat("en-Us").format(
                          account.transactions.reduce(
                            (sum, t) => sum + parseFloat(t.credit),
                            0,
                          ),
                        )}
                      </td>
                      <td
                        style={{
                          color: "black",
                          fontWeight: "bolder",
                          fontSize: "14px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        {Intl.NumberFormat("en-Us").format(
                          Math.abs(
                            account.transactions[
                              account.transactions.length - 1
                            ].blnc,
                          ),
                        )}{" "}
                        {Math.abs(
                          account.transactions[account.transactions.length - 1]
                            .blnc,
                        ) !== 0
                          ? account.transactions[
                              account.transactions.length - 1
                            ].type
                          : ""}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>

        <div className="lower-content">
          <div>
            <div>
              <b className="fontchagerledger"></b>
            </div>
          </div>
          <div className="lower1">
            <div className="lower2">
              <b className="fontchagerledger">Accountant</b>
            </div>
          </div>
          <div className="lower1" id="lowerLast">
            <div className="lower2">
              {directorSign == 0 ? (
                <b className="fontchagerledger">Chief Executive</b>
              ) : (
                <b className="fontchagerledger">Director</b>
              )}
            </div>
          </div>
        </div>
        <hr className="page1-line" />
      </div>

      <div
        ref={tableRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <Table style={{ display: "none" }} responsive>
          <thead>
            <tr id="tbl" className="text-center">
              <th className="w-120px">Date</th>
              <th>VNoVType</th>
              <th>Description</th>
              <th>Debit</th>
              <th>Credit</th>
              <th className="text-center">Balance</th>
            </tr>
          </thead>

          <tbody>
            {newOpeningBln?.map((account, idx) => (
              <React.Fragment key={idx}>
                {/* Account Title Row */}
                <tr className="text-center text-color-primary">
                  <td
                    colSpan={6}
                    style={{
                      fontWeight: "bolder",
                      textAlign: "center",
                      fontSize: "14px",
                      borderTop: "2px solid black",
                      borderBottom: "2px solid black",
                    }}
                  >
                    {account.account_head?.title || account.account_head?.name}
                  </td>
                </tr>

                {/* Opening Balance Row */}
                <tr id="tbl" className="text-center text-black">
                  <th></th>
                  <th></th>
                  <th>Opening Balance</th>
                  <th>
                    {Intl.NumberFormat("en-Us").format(
                      account.openning_balance_debit,
                    )}
                  </th>
                  <th>
                    {Intl.NumberFormat("en-Us").format(
                      account.openning_balance_credit,
                    )}
                  </th>
                  <th></th>
                </tr>

                {/* Transactions */}
                {account.transactions?.map((item, i) => (
                  <tr id="tbl" className="text-center" key={i}>
                    <td style={{ color: "black" }}>{item?.voucher?.date}</td>
                    <td style={{ color: "black" }}>
                      {item.voucher?.voucher_no}
                    </td>
                    <td style={{ color: "black" }} className="text_align_start">
                      {item?.remarks &&
                      typeof item.remarks === "string" &&
                      !item.remarks.includes("Campus") &&
                      item?.campus
                        ? item?.remarks + " ( " + item?.campus?.name + " )"
                        : item?.remarks}
                    </td>
                    <td style={{ color: "black" }}>
                      {Intl.NumberFormat("en-Us").format(item.debit)}
                    </td>
                    <td style={{ color: "black" }}>
                      {Intl.NumberFormat("en-Us").format(item.credit)}
                    </td>
                    <td style={{ color: "black", width: "150px" }}>
                      {Intl.NumberFormat("en-Us").format(Math.abs(item.blnc))}{" "}
                      {Math.abs(item.blnc) !== 0 ? item.type : ""}
                    </td>
                  </tr>
                ))}

                {/* Subtotal Row */}
                {subtoatal && account.transactions?.length > 0 && (
                  <tr id="tbl" className="text-center">
                    <td colSpan={2}></td>
                    <td
                      style={{
                        color: "black",
                        fontWeight: "bolder",
                        textAlign: "end",
                        fontSize: "16px",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                    >
                      Grand Total :-{" "}
                    </td>
                    <td
                      style={{
                        color: "black",
                        fontWeight: "bolder",
                        fontSize: "16px",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        account.transactions.reduce(
                          (sum, t) => sum + parseFloat(t.debit),
                          0,
                        ),
                      )}
                    </td>
                    <td
                      style={{
                        color: "black",
                        fontWeight: "bolder",
                        fontSize: "16px",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        account.transactions.reduce(
                          (sum, t) => sum + parseFloat(t.credit),
                          0,
                        ),
                      )}
                    </td>
                    <td
                      style={{
                        color: "black",
                        fontWeight: "bolder",
                        fontSize: "16px",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        Math.abs(
                          account.transactions[account.transactions.length - 1]
                            .blnc,
                        ),
                      )}{" "}
                      {Math.abs(
                        account.transactions[account.transactions.length - 1]
                          .blnc,
                      ) !== 0
                        ? account.transactions[account.transactions.length - 1]
                            .type
                        : ""}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default BankTransactionDateWise;
